import { render, staticRenderFns } from "./RenderGlass.vue?vue&type=template&id=5aefeff2&scoped=true"
import script from "./RenderGlass.vue?vue&type=script&lang=js"
export * from "./RenderGlass.vue?vue&type=script&lang=js"
import style0 from "./RenderGlass.vue?vue&type=style&index=0&id=5aefeff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aefeff2",
  null
  
)

export default component.exports